import { render } from "./linkBandiereView.vue?vue&type=template&id=a165c6ae"
import script from "./linkBandiereView.vue?vue&type=script&lang=js"
export * from "./linkBandiereView.vue?vue&type=script&lang=js"

import "./linkBandiereView.vue?vue&type=style&index=0&id=a165c6ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__